export const MAX_LENGTH_QUESTION = 150;
